/* global TweenMax TimelineMax Sine Circ Quad Quint Expo:true  */

import Viewport from '@vaersaagod/tools/Viewport';
import Dispatch from '@vaersaagod/tools/Dispatch';
import $ from '@vaersaagod/tools/Dom';
import * as Events from '../lib/events';

export default el => {
    let isOpen = false;

    const dom = $(el);
    const menu = dom.find('[data-menu]');
    const overlay = dom.find('[data-overlay]');

    const keyup = e => {
        const key = e.keyCode || e.which;

        if (key === 27) {
            Dispatch.emit(Events.MENU_CLOSE);
        }
    };

    const open = () => {
        if (!isOpen) {
            isOpen = true;
            TweenMax.set(el, { display: 'block' });
            TweenMax.to(menu.get(0), 0.75, { xPercent: 0, ease: Quint.easeInOut });
            TweenMax.to(overlay.get(0), 0.75, { opacity: 1, ease: Quad.easeIn });
            document.addEventListener('keyup', keyup);
        }
    };

    const close = () => {
        if (isOpen) {
            isOpen = false;
            document.removeEventListener('keyup', keyup);
            new TimelineMax()
                .to(menu.get(0), 0.75, { xPercent: -100, ease: Quint.easeOut }, '0')
                .to(overlay.get(0), 0.75, { opacity: 0 }, '0')
                .set(el, { display: 'none' });
        }
    };

    const init = () => {
        TweenMax.set(overlay.get(0), { opacity: 0 });
        TweenMax.set(menu.get(0), { xPercent: -100 });
        Dispatch.on(Events.MENU_OPEN, open);
        Dispatch.on(Events.MENU_CLOSE, close);
        overlay.on('click', () => {
            Dispatch.emit(Events.MENU_CLOSE);
        });
    };

    const destroy = () => {
        Dispatch.off(Events.MENU_OPEN, open);
        Dispatch.off(Events.MENU_CLOSE, close);
        overlay.off('click');
        TweenMax.killChildTweensOf(el);
    };

    return {
        init,
        destroy
    };
};



// WEBPACK FOOTER //
// ./src/js/components/Menu.js